import { render, staticRenderFns } from "./Tpchild.vue?vue&type=template&id=a8d1062c&scoped=true"
import script from "./Tpchild.vue?vue&type=script&lang=js"
export * from "./Tpchild.vue?vue&type=script&lang=js"
import style0 from "./Tpchild.vue?vue&type=style&index=0&id=a8d1062c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d1062c",
  null
  
)

export default component.exports